import { apiSlice } from "./apiSlice";
import config from "../../config.json";

export const workflowApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadWorkflowTask: builder.query({
      query: (wiid) => (config.GetWorkflowTask || "") + wiid,
      providesTags: ["WorkflowTasks"],
    }),
    workflowTaskDone: builder.mutation({
      query: (data) => ({
        url: config.SetWorkItemToDone,
        method: "POST",
        body: data,
      }),
    }),
    executeBprmFormRule: builder.mutation({
      query: (data) => ({
        url: config.ExcuteFormRule || "Form/GetFormRule",
        method: "POST",
        body: data,
      }),
    }),
    loadCurrentWorkflowTask: builder.mutation({
      query: (data) => ({
        url: config.GetCurrentWorkflowTask || "Engine/GetCurrentWorkflowTask",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["WorkflowTasks"],
    }),
  }),
});

export const {
  useLoadWorkflowTaskQuery,
  useLazyLoadWorkflowTaskQuery,
  useWorkflowTaskDoneMutation,
  useExecuteBprmFormRuleMutation,
  useLoadCurrentWorkflowTaskMutation,
} = workflowApiSlice;
